import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { OverlayInteraction, OverlayStatus } from 'common/types/tracking';

const enum ZoomState {
  In = 'zoom in',
  Out = 'zoom out',
}

export const dispatchZoomInOut = (zoom: boolean, isZoomIn: boolean) => {
  if (zoom !== isZoomIn) {
    dispatchTrackingEventGA4({
      event: 'product-gallery_click',
      element: 'product-gallery-main-slide-container',
      overlay: 'open',
      interaction: zoom ? ZoomState.In : ZoomState.Out,
    });
  }
};

export const dispatchSlideChange = ({
  element,
  index,
  listLength,
}: {
  element: string;
  index: number;
  listLength: number;
}) => {
  dispatchTrackingEventGA4({
    event: 'product-gallery_click',
    element,
    overlay: OverlayStatus.Open,
    list_position: index + 1,
    list_length: listLength,
    interaction: OverlayInteraction.ChangeMainImage,
  });
};
